import login from './loginReducer'
import simulations from './simulationsReducer'
import application from './applicationReducer'
import localSimulation from './localSimulationReducer'
import portfolios from  './portfoliosReducer'
import theme from  './themeReducer'

export default { login, simulations, application, localSimulation, portfolios, theme }
